import homeActive from "assets/images/carBlue.svg";
import myrideActive from "assets/images/myrideActive.svg";
import myrideInactive from "assets/images/myrideInactive.svg";
import help from "assets/images/help.svg";
import safety from "assets/images/safetyGrey.svg";
import safetyActive from "assets/images/safetyActive.svg";
import helpActive from "assets/images/helpActive.svg"
import homeInActive from "assets/images/homeInActive.svg";

export const headerUnAuth = [
    {
        id:1,
        field:'Home',
        path:'home',
        icon:homeInActive,
        activeIcon:homeActive,
    },
    {
        id:2,
        field:'My Ride',
        path:'myride',
        icon:myrideInactive,
        activeIcon:myrideActive ,
        tokenRequired:true
    },
    {
        id:3,
        field:'Help',
        path:'help',
        loginPath:'helpFaq',
        icon:help,
        activeIcon:helpActive,
    },
    {
        id:4,
        field:'Safety',
        path:'safety',
        icon:safety,
        activeIcon:safetyActive,
    }
]
export const headerAuth = [
    {
        id:1,
        field:'Home',
        path:'home',
        icon:homeInActive,
        activeIcon:homeActive,
    },
    {
        id:2,
        field:'My Ride',
        path:'myride',
        icon:myrideInactive,
        activeIcon:myrideActive ,
        tokenRequired:true
    },
    {
        id:3,
        field:'Help',
        path:'helpFaq',
        icon:help,
        activeIcon:helpActive,
    },
    {
        id:4,
        field:'Safety',
        path:'safety',
        icon:safety,
        activeIcon:safetyActive,
    }
]